<template>
  <div class="turnitin-account-container">
    <div class="header-div">
      <h5 class="primary-label mt-2">Manage Turnitin</h5>
      <a v-if="!turnitinServices || turnitinServices.length === 0" class="btn btn-sm btn-primary" @click="addTurnitinService()" target="_blank" rel="noopener noreferrer">
        Connect
      </a>
      <a v-else class="btn btn-sm btn-primary" @click="isUpdateWarningVisible = true">
        Update
      </a>
    </div>

    <b-modal id="turnitin-update-warning" v-model="isUpdateWarningVisible"
             title="Update Turnitin account" centered>
      <p>Connecting different Turnitin details can affect assignments that are already using similarity checking:</p>
      <ul class="mb-3">
        <li>Checks that are still running may fail</li>
        <li>Reports already produced may no longer open</li>
        <li>Students may be asked to accept the Turnitin agreement again</li>
      </ul>
      <template #modal-footer>
        <button class="btn btn-sm btn-secondary" @click="isUpdateWarningVisible = false">Cancel</button>
        <button class="btn btn-sm btn-primary" @click="confirmUpdateTurnitinService()">Continue</button>
      </template>
    </b-modal>
    <br/>
    <div class="settings-container">
      <div v-if="!isLoading">
        <div v-if="turnitinServices && turnitinServices.length > 0">
          <div class="card" v-for="service in turnitinServices">
            <div class="card-block">
              <div class="row align-items-center justify-content-center">
                <div class="col-auto">
                  <img class="img-fluid rounded-circle" style="width:45px; height: 45px; object-fit:contain"
                       src="../../../assets/images/turnitin-logo.png"/>
                </div>
                <div class="col">
                  <h5 style="margin: 0px;">{{ service.serviceName }}</h5>
                  <span class="text-muted">Similarity checking for assignments</span><br/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text-muted">
            Turnitin is not connected.
          </p>
        </div>

      </div>
      <div class="ms-4" v-if="isLoading">
        <b-spinner class="loader"></b-spinner>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "TurnitinServiceIntegration",
  data() {
    return {
      turnitinServices: [],
      isLoading: false,
      isUpdateWarningVisible: false
    };
  },
  methods: {
    ...mapActions("appState", ["fetchExternalServices"]),
    loadTurnitinServices() {
      this.isLoading = true;
      this.fetchExternalServices("TurnitinSimilarityCheck").then(() => {
        const list = this.externalServicesList && this.externalServicesList["TurnitinSimilarityCheck"] && this.externalServicesList["TurnitinSimilarityCheck"].filter(
            (service) => service.serviceProvider && service.serviceProvider.toLowerCase() === "turnitin"
        );
        this.isLoading = false;
        this.turnitinServices = list;
      });
    },
    confirmUpdateTurnitinService() {
      this.isUpdateWarningVisible = false;
      this.addTurnitinService();
    },
    addTurnitinService() {
      const left = (screen.width / 2) - (650 / 2);
      const top = (screen.height / 2) - (screen.height * 0.7 / 2);

      window.open("/service/turnitin", "Turnitin Integration", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + 650 + ',height=' + screen.height * 0.7 + ', top=' + top + ', left=' + left);

      const self = this;

      window.beforeCloseCallback = function () {
        self.loadTurnitinServices();
      };
    }
  },
  computed: {
    ...mapState("appState", ["externalServicesList"]),

  },
  created() {
    this.loadTurnitinServices();
  },
  watch: {},
}
</script>

<style scoped>
.turnitin-account-container {
  max-width: 35%;
}

.turnitin-account-container .header-div {
  display: flex;
  align-items: center;
}

.turnitin-account-container .header-div h5 {
  flex: 1;
}

.service-icon {
  font-size: 28px;
  color: var(--primary-color);
}

.card {
  border-radius: 0;
  -webkit-box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);
  box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);
  border: none;
  margin-bottom: 10px;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.card-block {
  padding: 10px;
}

@media only screen and (max-width: 1050px) {
  .turnitin-account-container {
    max-width: 50%;
  }
}

@media only screen and (max-width: 730px) {
  .turnitin-account-container {
    max-width: 100%;
  }
}
</style>
